<!--每月账单报表-->
<template>
  <div>

    <!--    /*left-text="返回" left-arrow  @click-left="onClickLeft"*/
    <van-nav-bar :title="title" >
    </van-nav-bar> -->

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
          v-model="loading"
          :finished="finished"
          finished-text="哥哥找过了,没有更多了,爱宝爱宝"
          loading-text="快点快点,不能让宝等太久"
          @load="onLoad">
        <van-cell v-for="item in list" >

          <!-- 使用 title 插槽来自定义标题 -->
          <template slot="title">
            <van-row type="flex" justify="space-between">
              <van-col span="12" >
                <!--                                <van-icon name="balance-list" size="20" style="margin-right: 15px"/>-->
                <span style="font-size: 20px">{{item.month}}</span>
              </van-col>
              <van-col span="6" offset="6">

                <span style="float: right" ><van-icon name="notes-o" size="23px" color="#fe7844" @click="goToFinList(item.month)"/></span>
              </van-col>
            </van-row>
            <van-row type="flex" justify="space-between">
              <van-col span="12"><span style="float: right;font-size: 16px">支出</span></van-col>
              <van-col span="12"><span style="float: right;font-size: 16px">收入</span></van-col>

            </van-row>

            <van-row type="flex" justify="space-between">
              <van-col span="4">
                <span style="float: left;color:#969799;font-size: 12px">日常</span>
              </van-col>
              <van-col span="8" @click="goToFinList(item.month,busiConsts.COMMON_TRUE,busiConsts.FIN_TYPE_PAY)" >
                <span style="float: right;font-size: 16px;color:#ee0a24">￥-{{returnFloat(item.pay)}}</span>
              </van-col>
              <van-col span="12" @click="goToFinList(item.month,busiConsts.COMMON_TRUE,busiConsts.FIN_TYPE_INCOME)" >
                <span style="float:right;font-size: 16px;color:#1989fa">￥{{returnFloat(item.income)}}</span>
              </van-col>
            </van-row>
            <van-row type="flex" justify="space-between">
              <van-col span="4">
                <span style="float: left;color:#969799;font-size: 12px">专项</span>
              </van-col>
              <van-col span="8"  @click="goToFinList(item.month,busiConsts.COMMON_FALSE,busiConsts.FIN_TYPE_PAY)">
                <span style="float: right;font-size: 16px;color:#ee0a24">￥-{{returnFloat(item.special_pay)}}</span>
              </van-col>
              <van-col span="12" @click="goToFinList(item.month,busiConsts.COMMON_FALSE,busiConsts.FIN_TYPE_INCOME)">
                <span style="float:right;font-size: 16px;color:#1989fa">￥{{returnFloat(item.special_income)}}</span>
              </van-col>
            </van-row>
            <van-row type="flex" justify="space-between">
              <van-col span="4">
                <span style="float: left;color:#969799;font-size: 12px">合计</span>
              </van-col>
              <van-col span="8"  >
                <span style="float: right;font-size: 20px;color:#ee0a24">￥-{{returnFloat(item.pay+item.special_pay)}}</span>
              </van-col>
              <van-col span="12" >
                <span style="float:right;font-size: 20px;color:#1989fa">￥{{returnFloat(item.income+item.special_income)}}</span>
              </van-col>
            </van-row>

            <van-row type="flex" justify="space-between">
              <van-col span="24" >
                <span style="float: right;color:#969799;font-size: 12px">月结余:￥{{computeBalance(item.income+item.special_income,item.pay+item.special_pay)}}</span>
              </van-col>

            </van-row>
          </template>

        </van-cell>

      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import FinNav from '../other/FinNav'
import * as MyApi from '../../api/URLApiAddr.js'
import * as BusiConsts from "../../common/BusiConsts";

export default {
  name: "FinReport",
  components: {
    FinNav
  },
  data() {
    return {
      title : '账单列表',
      busiConsts: BusiConsts,
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      tagType: "danger",
      pageInfo:{
        current:1,
        size:12,
        total:-1
      }
    }
  },
  methods: {
    onLoad() {

      if (this.refreshing) {
        this.list = [];
        this.pageInfo.current = 1
        this.pageInfo.total=-1
        this.refreshing = false
      }

      debugger

      if(this.pageInfo.total == this.list.length){
        ths.finished = true;
        return false
      }
      let params = this.pageInfo
      let ths = this

      this.$axios.post(MyApi.QRY_FIN_REPORT,params/*,options*/)
          .then((resp) =>  {

            let data = resp.data
            if(data.records.length >0){
              ths.pageInfo.current ++
              ths.list = ths.list.concat(data.records)
              ths.pageInfo.total = data.total
              if(ths.list.length == data.total){
                this.finished = true;
              }
            }else{
              this.finished = true;
            }

            this.loading = false;


          })
          .catch((err) =>{
            this.$toast.fail("数据初始化异常");
          })

    },
    computeBalance(income,pay){
      let balance = income-pay
      return balance.toFixed(2)
    },
    onClickLeft() {
      history.back();
    },
    /**
     *
     * @param month
     * @param statisticsFlag 统计类型
     * @param finType 收支类型
     */
    goToFinList(month,statisticsFlag,finType){
      let params = {month:month};
      //有值则赋值
      if(statisticsFlag >= 0){
        params.statisticsFlag = statisticsFlag
      }
      if(finType){
        params.finType = finType
      }

      this.$router.push({ name:'finList',params:params })
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    returnFloat(inputValue){
      let value = Math.round(parseFloat(inputValue)*100)/100;
      let xsd=value.toString().split(".");
      if(xsd.length==1){
        value=value.toString()+".00";
        return value;
      }
      if(xsd.length>1){
        if(xsd[1].length<2){
          value=value.toString()+"0";
        }
        return value;
      }
    }

  }
}
</script>

<style scoped>
.van-list >>> .van-list__finished-text{
  margin-bottom: 50px;
}

</style>
